import React, { useEffect } from "react";
import Tabs from "../components/home/tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { checkTokenValidation } from "../helperFunctions";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation()

  var authToken = localStorage.getItem("bearerToken");
  useEffect(() => {
    if (!authToken) {
      if (location.pathname != "/register") {
        navigate("/login");
      }
    } else {
      checkTokenValidation().then((res) => {
        if (!res) {
          console.log(res)
        }
      })
    }
  }, [])
  return (
    <div>
      <Tabs />
    </div>
  );
};

export default Home;
